import {Injectable} from '@angular/core';
import {JsonService} from './json.service';
import {TypeValuePair} from '../models/type-value-pair';

@Injectable({
  providedIn: 'root',
})
export class CustomJsonDataService extends JsonService {
  constructor() {
    super();
  }

  /**
   * Simplify retrieving of customJsonData
   *
   * @param dataHolderObject - Object where customJsonData should be extracted from
   * @param dataFieldType - customJsonData field type
   */
  getDataFieldOfType(dataHolderObject: {data?: TypeValuePair[]}, dataFieldType: string): any {
    if (dataHolderObject?.data) {
      return this.getJsonDataValue(dataHolderObject?.data, dataFieldType);
    }
  }
}
